<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formSector">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteSector()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="sectorContract.userNameCreate"
              [createDate]="sectorContract.createDate" [userNameUpdate]="sectorContract.userNameUpdate"
              [updateDate]="sectorContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col field-city">
              <app-custom-inputgroup [inputValue]="city" [labelText]="'Ciudad'" [iconButton]="'pi pi-external-link'"
                [titleButton]="'Seleccionar Ciudad'" [required]="true" [recovery]="true"
                (onClick)="openCitySelectionModal()"></app-custom-inputgroup>
              <app-custom-modal #selectCity [label]="'Seleccionar'" [header]="'Selección de Ciudades'" [width]="'80vw'"
                [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$" [output$]="output$"
                (selectedItems)="setCityDepartment($event)" hidden></app-custom-modal>
            </div>
            <div class="col field-department">
              <app-custom-input-text [value]="department" [labelText]="'Departamento'" [required]="true"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-consecutive">
              <app-custom-input-number formControlName="consecutive" [labelText]="'Código'" [required]="true"
                [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
            </div>
            <div class="col field-name">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col field-send">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>